/**
 * ApplicationInsights connection strings by region
 */
export const TelemetryConnectionStrings = {
    Prod: "InstrumentationKey=a50a8758-f662-4cba-a438-6f1f1282fe60;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/",
    ProdEU: "InstrumentationKey=1f4f966a-bd39-4478-b3db-1d84a0b5e47c;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/",
    PreProd: "InstrumentationKey=ba5bf7b5-a27c-499c-a3c2-ee140f81f4cc;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/",
    Test: "InstrumentationKey=f56f5ee3-f7e3-41d0-ab37-7f3e69c9ecf1;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/",
    NoTelemetry: "InstrumentationKey=00000000-0000-0000-0000-000000000000",
}
